<template>
    <div class="supervisors">
        <ag-table :data-source-api="getAllSupervisors" :grid-options="gridOptions" :permissions="permissions"
            :rtl="false" :is-entities-response="false" @emitAddNewRecord="onCreateSupervisor()" />

        <tm-popup :submit="onSupervisorPopupSubmit" :title="supervisorPopupTitle" ref="supervisorPopup">
            <div class="vx-row justify-start">
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
                    <tm-input class="w-full" name="الاسم" placeholder="الاسم" type="text" validation-rules="required"
                        v-model="supervisor.name" />
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
                    <tm-input class="w-full" name="رقم الموبايل" placeholder="رقم الموبايل" type="number"
                        v-model="supervisor.phoneNumber"
                        :validation-rules="{ required: true, syrianPhone: true }" />
                </div>
                <div class="vx-col w-full mb-2 mt-2">
                    <tm-select class="w-full" :options="volunteerGroupsOptions" label="name"
                        :validation-rules="needsVolunteerGroup ? 'required' : ''" name="المجموعات"
                        :reduce="(group) => group.id" multiple v-model="supervisor.volunteerGroupIds" />
                </div>
                <div class="vx-col w-full mb-2 mt-4">
                    <label>الصلاحيات</label>
                    <div class="vx-row mt-2">
                        <div class="vx-col sm:w-1/2 w-full mb-3" v-for="(label, key) in permissionLabels" :key="key">
                            <vs-checkbox :value="supervisor.permissions.includes(key)"
                                @input="togglePermission(key, $event)">
                                {{ label }}
                            </vs-checkbox>
                        </div>
                    </div>
                    <p class="text-grey" style="font-size: smaller">
                        عرض المهام والمجموعات ورسائل الشكر يتطلب اختيار مجموعة واحدة على الأقل، وتسجيل الحضور يتطلب
                        عرض جلسات زادي.
                    </p>
                </div>
            </div>
        </tm-popup>
    </div>
</template>

<script>
import { RepositoryFactory } from '../volunteer-repositories/volunteerRepositoryFactory';
import AgTable from '@/app/shared/shared-components/ag-grid/AgTableServerSide';
import AgTableBtnCell from '@/app/shared/shared-components/ag-grid/AgTableBtnCell';
import TmSelect from '@/app/shared/shared-components/TmSelect';
import TmPopup from '@/app/shared/shared-components/TmPopup';
import TmInput from '@/app/shared/shared-components/TmInput';
import SupervisorPermissionsCell from '../components/SupervisorPermissionsCell';
import {
    SUPERVISOR_PERMISSION_LABELS,
    SUPERVISOR_GROUP_PERMISSIONS,
    SUPERVISOR_DEFAULT_PERMISSIONS,
} from '../models';
import { extend } from 'vee-validate';

extend('syrianPhone', {
    validate: (value) => /^(9639)[0-9]{8}$/.test(value),
    message: 'رقم الموبايل غير صالح، يجب أن يبدأ بـ 9639 ويتكون من 12 رقماً (مثال: 963912345678)',
});

const supervisorsRepo = RepositoryFactory.get("supervisorsRepository");

export default {
    name: "SupervisorsManagement",
    components: {
        TmInput,
        AgTable,
        TmPopup,
        TmSelect,
        // eslint-disable-next-line vue/no-unused-components
        AgTableBtnCell,
        // eslint-disable-next-line vue/no-unused-components
        SupervisorPermissionsCell,
    },
    data() {
        return {
            gridApi: null,
            gridOptions: null,
            supervisorPopupTitle: 'إضافة مشرف جديد',
            permissions: {
                add: "supervisors_management",
                edit: "supervisors_management",
                delete: "supervisors_management",
            },
            supervisor: {
                id: null,
                name: null,
                phoneNumber: null,
                volunteerGroupIds: [],
                permissions: [],
            },
            volunteerGroups: [],
            permissionLabels: SUPERVISOR_PERMISSION_LABELS,
        };
    },
    computed: {
        volunteerGroupsOptions() {
            return this.volunteerGroups.map(group => ({
                id: group.id,
                name: group.name,
            }));
        },
        needsVolunteerGroup() {
            return this.supervisor.permissions.some((key) => SUPERVISOR_GROUP_PERMISSIONS.includes(key));
        },
        // isEditMode() {
        //     return this.supervisorPopupTitle === 'تعديل مشرف';
        // },
    },
    methods: {
        createColDefs() {
            let self = this;
            return [
                {
                    headerName: "المعرف",
                    field: "id",
                    sortable: false,
                    width: 200,
                },
                {
                    headerName: "الاسم",
                    field: "name",
                    filter: "agTextColumnFilter",
                    width: 210,
                    sortable: true,
                },
                {
                    headerName: "رقم الموبايل",
                    field: "phoneNumber",
                    filter: "agTextColumnFilter",
                    width: 210,
                    sortable: false,
                },
                {
                    headerName: "المجموعات",
                    sortable: false,
                    width: 260,
                    valueGetter: (params) =>
                        (params.data.volunteerGroups || []).map(g => g.name).join(' - ') || '-',
                },
                {
                    headerName: "الصلاحيات",
                    field: "permissions",
                    sortable: false,
                    width: 480,
                    cellRendererFramework: SupervisorPermissionsCell,
                },
                {
                    headerName: "الإجراءات",
                    cellRendererFramework: AgTableBtnCell,
                    sortable: false,
                    valueGetter: function getObject(params) {
                        return params.data;
                    },
                    cellRendererParams: {
                        editRecord: function (supervisor) {
                            self.onUpdateSupervisor(supervisor);
                        },
                        // deleteRecord: function (supervisor) {
                        //     self.onRemoveSupervisor(supervisor);
                        // },
                        // changePassword: function (supervisor) {
                        //     self.onResetSupervisorPassword(supervisor);
                        // },
                        // actions: ["edit", "delete", "change-password"],
                        actions: ["edit"],
                        permissions: self.permissions,
                    },
                },
            ];
        },
        // async onRemoveSupervisor(supervisor) {
        //     await supervisorsRepo.removeSupervisor(supervisor.id);
        //     await this.gridApi.refreshServerSideStore({ purge: true });
        // },
        // async onResetSupervisorPassword(supervisor) {
        //     this.$vs.dialog({
        //         type: 'confirm',
        //         color: 'warning',
        //         title: 'إعادة تعيين كلمة المرور',
        //         text: `هل أنت متأكد من إعادة تعيين كلمة مرور المشرف "${supervisor.name}"؟`,
        //         accept: async () => {
        //             try {
        //                 const res = await supervisorsRepo.resetSupervisorPassword(supervisor.id);
        //                 if (res.status === 201 || res.status === 200) {
        //                     await this.gridApi.refreshServerSideStore({ purge: true });
        //                 }
        //             } catch (err) {
        //                 // Error handling is done by httpClient interceptor
        //             }
        //         },
        //         acceptText: 'تأكيد',
        //         cancelText: 'إلغاء',
        //     });
        // },
        async getAllSupervisors(query) {
            return await supervisorsRepo.fetchSupervisors(`${query}&sort=createdAt,DESC`);
        },
        async fetchVolunteerGroups() {
            const response = await supervisorsRepo.fetchVolunteerGroups();
            this.volunteerGroups = response.data || [];
        },
        onUpdateSupervisor(supervisor) {
            this.supervisorPopupTitle = 'تعديل مشرف';
            this.resetSupervisorForm();
            Object.assign(this.supervisor, {
                id: supervisor.id,
                name: supervisor.name,
                phoneNumber: supervisor.phoneNumber,
                volunteerGroupIds: (supervisor.volunteerGroups || []).map(g => g.id),
                permissions: supervisor.permissions || [],
            });
            this.$refs.supervisorPopup.open();
        },
        onCreateSupervisor() {
            this.supervisorPopupTitle = 'إضافة مشرف جديد';
            this.resetSupervisorForm();
            this.supervisor.permissions = SUPERVISOR_DEFAULT_PERMISSIONS.slice();
            this.$refs.supervisorPopup.open();
        },
        resetSupervisorForm() {
            Object.assign(this.supervisor, {
                id: null,
                name: null,
                phoneNumber: null,
                volunteerGroupIds: [],
                permissions: [],
            });
        },
        // تسجيل الحضور يتطلب عرض جلسات زادي، فتحديده يحدد العرض وإلغاء العرض يلغيه
        togglePermission(key, checked) {
            let permissions = this.supervisor.permissions.filter((item) => item !== key);
            if (checked) permissions.push(key);
            if (checked && key === 'check_in_zadi_sessions' && !permissions.includes('view_zadi_sessions'))
                permissions.push('view_zadi_sessions');
            if (!checked && key === 'view_zadi_sessions')
                permissions = permissions.filter((item) => item !== 'check_in_zadi_sessions');
            this.supervisor.permissions = permissions;
        },
        async onSupervisorPopupSubmit() {
            const payload = {
                name: this.supervisor.name,
                phoneNumber: this.supervisor.phoneNumber,
                volunteerGroupIds: this.supervisor.volunteerGroupIds,
                permissions: this.supervisor.permissions,
            };
            try {
                this.$refs.supervisorPopup.loading();
                if (this.supervisorPopupTitle == 'إضافة مشرف جديد') {
                    await supervisorsRepo.createSupervisor(payload);
                } else {
                    await supervisorsRepo.updateSupervisor(this.supervisor.id, payload);
                }
                this.$refs.supervisorPopup.close();
                await this.gridApi.refreshServerSideStore({ purge: true });
                this.resetSupervisorForm();
            } finally {
                this.$refs.supervisorPopup.endLoading();
            }
        },
    },
    created() {
        this.gridOptions = {};
        this.gridOptions.columnDefs = this.createColDefs();
        this.fetchVolunteerGroups();
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
};
</script>
